import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const el = document.querySelector('.logo-slider__swiper');
    if (!el) {
        return;
    }

    new Swiper(el, {
        modules: [Autoplay],
        loop: true,
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 10,
        autoplay: {
            delay: 2500,
            waitForTransition: false
        },
        allowTouchMove: false,
        breakpoints: {
            782: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1140: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });
});